module.exports = __webpack_public_path__ + "static/fhaLoanbg-old-a23e108e74650c884dae8b027e0a6d6e.jpg";